import { Input, OnInit, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  Form, FormElement, ViewState,
  MessagesComponent,
  FormElementValidators,
  Auth,
  TranslationEntityComponent
} from 'src/common';
import { InternalUserViewModel, InternalUsersService, UserStatusModel, RolesService, RoleModel, RolesInUserModel } from 'src/common';
import { TranslationManager } from 'src/common/translation';
import { RolesSelectComponent } from 'src/views/components/roles-select-component';

@Component({
  selector: 'app-internaluser',
  templateUrl: './internaluser.component.html'
})
export class InternalUserComponent implements OnInit {

  @Input() state: ViewState;
  viewState = ViewState;
  form: Form = new Form();
  translationManager = TranslationManager;
  model: InternalUserViewModel = new InternalUserViewModel();
  userstatusmodel: UserStatusModel[];
  rolemodel: RoleModel[];
  @ViewChild('roleSelect')
  roleSelect: RolesSelectComponent;

  constructor(private router: Router, public route: ActivatedRoute, private el: ElementRef, private internalusersService: InternalUsersService,
    private rolesService: RolesService) { }


  ngOnInit(): void {

    if (this.state == ViewState.Details) {
      Auth.checkAuthorization('AB9241CA-EF54-44BA-86DC-CCF446AE1BD8');
    } else if (this.state == ViewState.Edit) {
      Auth.checkAuthorization('5AA41EE6-B5D7-44B7-8D5E-CFE7925FED3C');
    }

    this.initForm();
    if (this.state === ViewState.Edit || this.state === ViewState.Details) {
      this.form.elements['id'].value = this.route.snapshot.params.id;
      this.internalusersService.getById(this.form.elements['id'].value).then((item: InternalUserViewModel) => {
        this.model = item;
        this.bindModelToForm(item);
      }).catch((reason: any) => {
        if (reason !== null) {
          if (reason.status === 400) {
            if (reason.error !== null) {
              if (reason.error.message) {
                const mescustom = reason.error.message;
                MessagesComponent.instance.showError([mescustom]);

              }
            }
          }
        }

      });

    }
    if (this.state === ViewState.Edit) {
      this.userstatusmodel = this.getUserStatusModel();
      this.rolesService.getAll().then(result => {
        this.rolemodel = result;
      });
    }

  }


  private initForm(): void {
    this.form.elements["id"] = new FormElement();

    this.form.elements["userErpId"] = new FormElement();
    this.form.elements["userStatusId"] = new FormElement();
    this.form.elements["userStatusId"].state.mandatory = true;

    this.form.elements["firstName"] = new FormElement();
    this.form.elements["lastName"] = new FormElement();
    this.form.elements["fullName"] = new FormElement();
    this.form.elements["email"] = new FormElement();
    this.form.elements["username"] = new FormElement();
    this.form.elements["organizationalUnitId"] = new FormElement();
    this.form.elements["companyId"] = new FormElement();
    this.form.elements["firstSuperiorId"] = new FormElement();
    this.form.elements["personnelAreaErpId"] = new FormElement();
    this.form.elements["personnelAreaName"] = new FormElement();
    this.form.elements["employeePositionErpId"] = new FormElement();
    this.form.elements["employeePositionName"] = new FormElement();
    this.form.elements["userStatusName"] = new FormElement();
    this.form.elements["companyName"] = new FormElement();
    this.form.elements["organizationalUnitName"] = new FormElement();
    this.form.elements["updatedBy"] = new FormElement();
    this.form.elements["updatedOn"] = new FormElement();
    this.form.elements["userUpdateFullName"] = new FormElement();
    this.form.elements["userFirstSuperiorFullName"] = new FormElement();
  }


  private bindModelToForm(item: InternalUserViewModel): void {

    this.form.elements['id'].value = item.id;
    this.form.elements["userErpId"].value = item.userErpId;
    this.form.elements["userStatusId"].value = item.userStatusId;
    this.form.elements["firstName"].value = item.firstName;
    this.form.elements["lastName"].value = item.lastName;
    this.form.elements["fullName"].value = item.fullName;
    this.form.elements["email"].value = item.email;
    this.form.elements["username"].value = item.username;
    this.form.elements["organizationalUnitId"].value = item.organizationalUnitId;
    this.form.elements["companyId"].value = item.companyId;
    this.form.elements["firstSuperiorId"].value = item.firstSuperiorId;
    this.form.elements["personnelAreaErpId"].value = item.personnelAreaErpId;
    this.form.elements["personnelAreaName"].value = item.personnelAreaName;
    this.form.elements["employeePositionErpId"].value = item.employeePositionErpId;
    this.form.elements["employeePositionName"].value = item.employeePositionName;
    this.form.elements["userStatusName"].value = item.userStatusName;
    this.form.elements["companyName"].value = item.companyName;
    this.form.elements["organizationalUnitName"].value = item.organizationalUnitName;
    this.form.elements["updatedBy"].value = item.updatedBy;
    this.form.elements["updatedOn"].value = item.updatedOn;
    this.form.elements["userUpdateFullName"].value = item.userUpdateFullName;
    this.form.elements["userFirstSuperiorFullName"].value = item.userFirstSuperiorFullName;
  }



  submit(): void {
    if (this.form.isValid()) {

      this.model.id = this.form.elements['id'].value;
      this.model.updatedOn = this.form.elements['updatedOn'].value;
      this.model.userStatusId = this.form.elements['userStatusId'].value;

      if (!this.model.userStatusId) {
        MessagesComponent.instance.showError([this.translationManager.getTranslation('Статус корисника мора бити изабран')]);
        return;
      }
      if (this.model.rolesNameAndId.length == 0) {
        MessagesComponent.instance.showError([this.translationManager.getTranslation('Мора постојати бар једна улога/рола за корисника')]);
        return;
      }

      if (this.state === ViewState.Edit) {
        this.internalusersService.save(this.model).then(() => {
          MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Успешно измењен ентитет')]);
          this.router.navigate(['internal-users']);
        }).catch((reason: any) => {
          if (reason !== null) {
            if (reason.status === 400) {
              if (reason.error !== null) {
                if (reason.error.message) {
                  const mescustom = reason.error.message;
                  MessagesComponent.instance.showError([mescustom]);
                }
              }
            } else {
              MessagesComponent.instance.showError(reason.error.messages);
            }
          }
        });
      }
    } else {
      for (const jjj of Object.keys(this.form.elements)) {
        if (this.form.elements[jjj].error.required || this.form.elements[jjj].error.invalid) {
          const invalidControl = this.el.nativeElement.querySelector('[name="' + jjj + '"]');
          if (invalidControl) {
            invalidControl.focus();
            break;
          }

        }
      }
    }
  }

  getUserStatusModel(): UserStatusModel[] {
    let userStatus: UserStatusModel[] = [
      { id: 0, name: this.translationManager.getTranslation('Неактиван') },
      { id: 1, name: this.translationManager.getTranslation('Активан') }
    ];
    return userStatus;
  }

  changeuserStatusId(id: number) {
    this.form.elements["userStatusId"].value = id;
  }


  deleteRole(id: number): void {
    this.model.rolesNameAndId.forEach((item, index) => {
      if (item.id == id) {
        this.model.rolesNameAndId.splice(index, 1);
      }
    });

  }


  addRole() {

    let roleid;
    let roles = this.model.rolesNameAndId;
    roles.forEach((item, index) => {
      roleid = item.id;
    });
    this.roleSelect.showModal(null).then((id: number) => {
      if (id > 0) {
        this.getRoleById(id);
      }
      else if (id === -1) {
        //nista nije selektovano
      }
    });
  }

  private getRoleById(id: number) {
    this.rolesService
      .getById(id)
      .then((item: RoleModel) => {
        //      prvo proveri ima li ga u array
        // ako ga ima nista ako ga nema dodaj
        let rolesAdd = this.model.rolesNameAndId;

        let newRole = new RolesInUserModel();
        newRole.id = item.id;
        newRole.name = item.name;

        const found = rolesAdd.find((element) => {
          return element.id === item.id;
        });

        if (found) {
          MessagesComponent.instance.showError([this.translationManager.getTranslation('Улога/рола за корисника већ је унета')]);
          return;
        } else {
          this.model.rolesNameAndId.push(newRole);
        }

      });
  }

  back(): void {
    this.router.navigate(['internal-users']);
  }
}
